import React, { useState, useEffect, useRef } from "react";
import { captureSubmissionError } from "../../utils/sentryUtils";
import SubmittingCard from "../../components/SubmittingCard";
import SubmissionErrorCard from "../../components/SubmissionErrorCard";

const RemoLeaseholdSubmission = ({ remortgageLeaseholdInformationFlowState: flowState, onFlowComplete }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Ref guard prevents StrictMode double-mount from firing a second request
  const hasInitiated = useRef(false);

  useEffect(() => {
    if (hasInitiated.current) return;
    hasInitiated.current = true;

    fetch("/api/remortgageLeaseholdInformation", {
      method: "PUT",
      body: JSON.stringify({
        formRequestId: flowState.formRequestId,
        transactionType: flowState.transactionType,
        hasChallengedCharges: flowState.leaseholdInformation.hasChallengedCharges,
        challengedChargesInfo: flowState.leaseholdInformation.challengedChargesInfo,
        hasReceivedNotices: flowState.leaseholdInformation.hasReceivedNotices,
        receivedNoticesInfo: flowState.leaseholdInformation.receivedNoticesInfo,
        hasReceivedComplaints: flowState.leaseholdInformation.hasReceivedComplaints,
        receivedComplaintsInfo: flowState.leaseholdInformation.receivedComplaintsInfo,
        firstManagementCompanyDetails: flowState.firstManagementCompanyDetails,
        secondManagementCompanyDetails: flowState.secondManagementCompanyDetails,
      }),
    })
      .then(
        async (resp) => {
          if (resp.ok) {
            setLoading(false);
            onFlowComplete();
          } else {
            const body = await resp.text().catch(() => "");
            console.error("Remo leasehold submission failed:", resp.status, body);
            captureSubmissionError("RemortgageLeasehold", resp.status, body);
            setError("Unable to process your details");
            setLoading(false);
          }
        },
        (err) => {
          console.error("Remo leasehold submission failed:", err);
          setError("Unable to process your details");
          setLoading(false);
        },
      )
      .catch((err) => {
        console.error("Remo leasehold submission failed:", err);
        setError("Unable to process your details");
        setLoading(false);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- submit once on mount; ref guard prevents StrictMode re-fire

  if (loading) {
    return <SubmittingCard />;
  }

  if (error) {
    return <SubmissionErrorCard error={error} />;
  }

  return null;
};

export default RemoLeaseholdSubmission;
